var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewPlaylist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37076 4.3525C6.22347 4.91208 5.52747 5.3075 4.13538 6.09837C2.78967 6.86287 2.11684 7.24517 1.5746 7.0915C1.35042 7.02796 1.14617 6.90733 0.981441 6.74112C0.583008 6.33912 0.583008 5.55942 0.583008 4C0.583008 2.44058 0.583008 1.66088 0.981441 1.25888C1.14617 1.09269 1.35042 0.972033 1.5746 0.908508C2.11684 0.754854 2.78967 1.13711 4.13538 1.90164C5.52747 2.69249 6.22347 3.08792 6.37076 3.6475C6.43155 3.8785 6.43155 4.1215 6.37076 4.3525Z",
    fill: "#0C6630",
    stroke: "#0C6630",
    strokeWidth: 0.625,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewPlaylist);
export default __webpack_public_path__ + "static/media/Preview_Playlist.b69d1d411554a4da1d9ad16f6f483df3.svg";
export { ForwardRef as ReactComponent };